module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Emerging Revolutionary War Series")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("offers compelling, easy-to-read overviews of some of the Revolutionary War’s most important battles and stories.")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Also part of the Emerging Revolutionary War Series:")])]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A Single Blow: The Battles of Lexington and Concord and the Beginning of the American Revolution, April 19, 1775")]), _vm._v(" by Phillip S. Greenwalt and Robert Orrison")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A Handsome Flogging: The Battle of Monmouth, June 28, 1778")]), _vm._v(" by William R. Griffith IV")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Winter that Won the War: The Winter Encampment at Valley Forge, 1777–1778")]), _vm._v(" by Phillip S. Greenwalt")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Unhappy Catastrophes: The American Revolution in Central New Jersey, 1776–1782")]), _vm._v(" by Robert M. Dunkerly")]), _vm._v(" "), _c('p', {
    staticClass: "fm2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Also by Mark Maloy")])]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Victory or Death: The Battles of Trenton and Princeton, December 25, 1776–January 3, 1777")])]), _vm._v(" "), _c('p', {
    staticClass: "fm3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("For a complete list of titles in the Emerging Revolutionary War Series, visit "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.emergingrevolutionarywar.org",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.emergingrevolutionarywar.org")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-466cde58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Fm01.vue
// module id = 60
// module chunks = 0